import { Loader } from '@neo/primitives/loader'
import { useAppStore } from 'v2/state/app'

export const OrgSwitchLoader = () => {
  const switchingToOrgName = useAppStore((state) => state.switchingToOrgName)
  if (!switchingToOrgName) return null

  return (
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-background"
      data-testid="org-switch-loader"
    >
      <Loader text={`Switching to ${switchingToOrgName}...`} />
    </div>
  )
}
